import { useEffect } from 'react';
import { useSelector } from 'react-redux';

// material-ui
import { Box, Button, Grid, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { NavLink } from 'react-router-dom';
import { contentWidth } from 'store/constant';
// assets
import hero from 'assets/images/hero.png';

import useAuth from 'hooks/useAuth';

// ==============================|| 404 PAGE ||============================== //


const MaintenancePage = () => {
    const market = useAuth();
    const market_settings = market?.company?.organisation
    useEffect(() => {

    }, []);

    return (
        <>
            <Box sx={{ maxWidth: contentWidth, margin: '75px auto' }}>
                <Box sx={{ marginBottom: '25px' }}>
                    <Typography variant="h1">
                        {market_settings?.maintenance_title ?  <>{market_settings?.maintenance_title}</> :
                        <FormattedMessage id="maintenance-page.title" />}
                    </Typography>
                </Box>
                {market_settings?.maintenance_message ? <Box sx={{ marginBottom: '25px' }}>
                    <p>&nbsp;</p>
                    <Typography dangerouslySetInnerHTML={{__html: market_settings?.maintenance_message}}></Typography>
                </Box> : <>
                    <Box sx={{ marginBottom: '25px' }}>
                        <Typography paragraph>
                            <FormattedMessage id="maintenance-page.text" />
                        </Typography>
                    </Box>
                    <Box sx={{ marginBottom: '25px' }}>
                        <Typography paragraph>
                            <FormattedMessage id="maintenance-page.thanks" />
                        </Typography>
                    </Box>
                </>}
                
            </Box>
        </>
    )
};

export default MaintenancePage;
